export enum SidebarButton {
  MASS_EDITING = 'MASS_EDITING',
  COLUMNS_CONFIGURATION = 'COLUMNS_CONFIGURATION',
  PRODUCT_CHOICE = 'PRODUCT_CHOICE'
}
